<template>
<md-list class="md-triple-line">
    <md-list-item v-for="mutation in mutations" :key="mutation.id">
        <div class="md-list-text-container">
            <span>{{mutation.project.title}}&nbsp;<span class="md-caption">{{mutation.version.version}}</span></span>
            <span>Changed By: {{mutation.mutation.user}}</span>
            <span>{{mutation.mutation.date.toDateString()}}</span>
        </div>
    </md-list-item>
</md-list>
</template>

<script>
const RevisionList = {
    name: 'revisionList',
    props: ['mutations'],
    data: function() {
        return {};
    },
    computed: {
    },
    methods: {
    }
};
export default RevisionList;
</script>


// WEBPACK FOOTER //
// revisions-list.vue?3e41890d